import type { RouteLocation } from '#vue-router'

export const useBookingRequestRedirection = () => {
  const bookingGuestStore = useBookingsGuestStore()

  const getRedirection = (route: RouteLocation) => {
    if (!isDefined(bookingGuestStore.bookingGuest)) {
      throw new Error('booking request redirection is missing mandatory data')
    }

    // redirect to instant booking request funnel
    if (bookingGuestStore.bookingGuestIsInstantBooking) {
      return {
        name: 'campers-id-instant-request-request_id',
        params: route.params,
      }
    }

    // redirection to dashboard
    if (!bookingGuestStore.bookingGuestIsAbandonned
      && !bookingGuestStore.bookingGuestIsValidated
    ) {
      return {
        name: 'd-trips-id',
        params: { id: bookingGuestStore.bookingGuest.id },
      }
    }

    // redirection to success
    if (bookingGuestStore.bookingGuestIsValidated
      && route.name !== 'campers-id-request-request_id-success'
    ) {
      return {
        name: 'campers-id-request-request_id-success',
        params: route.params,
      }
    }

    // redirection to first step if root
    if (route.name === 'campers-id-request-request_id') {
      return {
        name: 'campers-id-request-request_id-user-details',
        params: route.params,
      }
    }
  }

  return { getRedirection }
}
